import React, { Component, Fragment } from 'react';
import { Navigationmenu } from '../components';
import {
    Box,
    Button,
    Typography,
    Grid,
    TextField,
    IconButton,
    ButtonGroup,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Popover,
    Dialog,
    Tabs,
    Tab,
    DialogActions,
    withStyles,
    AppBar, Toolbar
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import {
    SearchOutlined,
    ArrowDropDown,
    Publish,
    NoteAdd,
    ArrowDropUp,
    InsertDriveFileOutlined,
    RepeatOneSharp
} from '@material-ui/icons';
import { FileCopy, Refresh, Add, Delete, Edit } from '@material-ui/icons';
// import { DataGrid } from '@material-ui/data-grid';
import circulargridimage from '../gallery/gridloader.gif';



import {
    ALTERNATEROW_BACKGROUND_COLOR,
    BLUE_COLOR, LIGHTGRAY_COLOR,
    MODIFIEDBLACK,
    PINK_COLOR,
    PROTECT_GREEN,
    RED_COLOR,
    VIBRANT_GREEN
} from "../constants";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import { Redirect } from "react-router-dom";
import { fnPostapiResponse, fnGETapiResponse, getUsername, Fnencryption } from '../APICall';


const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        backgroundColor: 'white',
        height: 3
    },
}, { index: 1 })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'white',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        '&:focus': {
            opacity: 1
        }
    },
}, { index: 1 }))((props) => <Tab disableRipple {...props} />);

export default class ArchiveDMS extends Component {

    state = {
        pages: 0,
        current: 1,
        records: 0,
        pageSize: 10,
        showPager: false,
        expanded: false, isloading: false,
        policynum: "policy type",
        period: "all",
        status: "all",
        anchorEl: null,
        open: false,
        ishovered: false,
        hoverindex: 0,
        showDialog: false,
        tabsvalue: 0,
        addpolicyholder: false,
        editinfo: false,
        tablebuffer: [
        ],
        pagesObj: [], startDate: this.getTodaydate(),
        endDate: this.getTodaydate(),
        selectedStatus: "All",
        selectedDepart: "Claims",
        displaypolicydetails: 'none',
        detailsHeader: "",
        displayFlowdetails: "none",
        eloworkflowtitle: '',
        tableflowbuffer: []
    }
    handleSerachChange(e, key) {
        this.setState({ key: e.target.value });
        this.state[key] = e.target.value;
    }
    componentDidMount() {
        // this.loadpendingData("")
        // this.getTodaydate()
    }

    formatedate(date) {
        var g = date.replace("-", "").replace("-", "")
        return g
    }
    pageChange(number) {
        this.state.current = number;
        var data = this.state.alldata.slice(this.state.current * this.state.pageSize, (this.state.current + 1) * this.state.pageSize);
        this.setState({ tablebuffer: data })

        this.state.pagesObj = [];
        if (this.state.pages < 10) {
            for (var i = 0; i < this.state.pages; i++)
                this.state.pagesObj.push(i);
        }
        else {
            var min = this.state.current - 5;
            var max = this.state.current + 5;
            if (min < 0)
                min = 0;
            if (max > this.state.pages)
                max = this.state.pages;
            if (max - min > 10) {
                min = this.state.current - 5;
                max = this.state.current + 5;
            }
            if (min > 0)
                this.state.pagesObj.push(0);
            for (var i = min; i < max; i++)
                this.state.pagesObj.push(i);
            if (max < this.state.pages - 1)
                this.state.pagesObj.push(this.state.pages - 1);
        }
    }
    renderpages() {
        this.state.records = this.state.alldata.length;
        this.state.pages = parseInt(this.state.records / this.state.pageSize)
        if (this.state.records % this.state.pageSize > 0)
            this.state.pages++;
        this.state.showPager = this.state.pages > 1
        this.pageChange(0)
    }
    getTodaydate() {
        var d = new Date();
        var month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1
        var date1 = d.getDate() < 10 ? "0" + (d.getDate()) : d.getDate()
        var CMLSELECTEDATE = d.getFullYear() + "-" + month + "-" + date1
        this.setState({
            startDate: CMLSELECTEDATE,
            endDate: CMLSELECTEDATE
        })
        return CMLSELECTEDATE
    }

    handleClick(event) {
        this.setState({ anchorEl: event.currentTarget, open: !this.state.open });
    };
    getParsedDate(strDate) {
        var strSplitDate = String(strDate).split(' ');
        var date = new Date(strSplitDate[0]);

        // alert(date);
        var dd = date.getDate();
        var mm = date.getMonth() + 1; //January is 0!

        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "-" + mm + "-" + yyyy;
        return date.toString();
    }
    handleClose() {
        this.setState({ anchorEl: null, open: !this.state.open, addpolicyholder: true });
    };

    handleChangeTabs(value) {
        this.setState({ tabsvalue: value });
    }


    /***
     *
     * @param n
     * @returns true if even number
     * @returns false if odd number
     */
    isEven(n) {
        return n % 2 == 0;
    }



    render() {
        return (
            <Fragment>
                {this.state.addpolicyholder && <Redirect to="/Addpolicyholder" />}
                {this.state.editinfo && <Redirect to="/Editpolicyholder" />}
                <Navigationmenu selectedMenu={'view_pending_requests'} />
                <Box
                    display="flex"
                    style={{ marginTop: '10vh' }}
                    alignItems="center"
                    justifyContent="center"
                >



                </Box>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{ marginTop: 35 }}
                >

                    <Paper elevation={2} style={{ minHeight: 100, width: '90%', borderRadius: 6 }}>

                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >

                            <div style={{ minHeight: 100, width: '98%', borderRadius: 6 }}>

                                <Grid container spacing={2}>
                                    <Grid item xs={11}>
                                        <div style={{
                                            display: 'flex',
                                            marginBottom: 20,
                                            marginTop: 20
                                        }}>
                                            <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 24, paddingLeft: 10 }}>
                                                Archived DMS</Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={2}>
                                        <TextField fullWidth label="Phiden" value={this.state.SelectedClientName}
                                            variant="outlined" 
                                            onChange={(e) => this.handleSerachChange(e, "SelectedClientName")}
                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                    <TextField fullWidth label="Surname" value={this.state.SelectedSurname}
                                            variant="outlined" 
                                            onChange={(e) => this.handleSerachChange(e, "SelectedSurname")}
                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />

                                    </Grid>
                                    <Grid item xs={2}>
                                    <TextField fullWidth label="Forename" value={this.state.SelectedForname}
                                            variant="outlined" 
                                            onChange={(e) => this.handleSerachChange(e, "SelectedForname")}
                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                    <TextField fullWidth label="Nic" value={this.state.SelectedNIC}
                                            variant="outlined" 
                                            onChange={(e) => this.handleSerachChange(e, "SelectedNIC")}
                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                    </Grid>


                                    <Grid item xs={2}>
                                        <Button variant={'contained'}
                                            style={{ marginTop: 0, width: '120px', height: '50px', marginLeft: 150, fontSize: "14px" }}
                                            onClick={e =>
                                                this.loadpendingData(this.state.selectedStatus)} >
                                            Load data
                                        </Button>

                                    </Grid>
                                </Grid>
                                     <div style={{marginTop:"15px"}}></div>           
                                <TableContainer>
                                    <Table aria-label="table">
                                        <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                            <TableRow>
                                                <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">Code</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">Document</TableCell>
                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold'}} align="center">Document Type</TableCell>
                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold'}} align="center">Request</TableCell>
                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">Remarks</TableCell>
                                                </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        <TableRow style={{ cursor: 'pointer' }} >
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',  }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} >IDN</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold',   }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} ><a href='http://www.africau.edu/images/default/sample.pdf' target='_blank'> <FileCopy  style={{ height: 32, width: 32, marginLeft: 5, marginTop:5,color:BLUE_COLOR }} /></a></Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',   }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }}>Certified copy of muntain</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',  }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }}>M</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',  }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }}></Typography></TableCell>
                                                                 </TableRow>
                                                                 <TableRow style={{ cursor: 'pointer' }}>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',  }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} >UTB</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold',   }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} ><a href='https://www.clickdimensions.com/links/TestPDFfile.pdf'  target='_blank'> <FileCopy  style={{ height: 32, width: 32, marginLeft: 5, marginTop: 5,color:BLUE_COLOR }} /></a></Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',   }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }}>Certified copy of proof of current address</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',  }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }}>M</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',  }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }}></Typography></TableCell>
                                                                 </TableRow>
                                                                 <TableRow style={{ cursor: 'pointer' }} >
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',  }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} >SOF</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold',   }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} ><a href='https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'  target='_blank'> <FileCopy  style={{ height: 32, width: 32, marginLeft: 5, marginTop: 5,color:BLUE_COLOR }} /></a></Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',   }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }}>Proof of source of fund</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',  }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }}>M</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold',  }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }}></Typography></TableCell>
                                                                 </TableRow>s
                                        </TableBody>
                                    </Table>
                                    <div style={this.state.showPager ? { height: 60, marginLeft: "500px", color: MODIFIEDBLACK, fontSize: "15px", textTransform: 'uppercase', fontFamily: 'Globerbold', wordBreak: "break-word" } : { display: "none" }} >
                                        {
                                            this.state.pagesObj.map((obj, index) => {
                                                return (
                                                    <span style={{ padding: "0 3px", cursor: "pointer" }}>
                                                        <a style={this.state.current == obj ? { fontWeight: 'bold', color: BLUE_COLOR, fontSize: "30px" } : {}} onClick={() => this.pageChange(obj)} >{obj + 1}</a>
                                                    </span>
                                                )
                                            })
                                        }
                                    </div>
                                </TableContainer>

                                <div style={{ height: 40 }} />
                            </div>

                        </Box>

                    </Paper>

                </Box>

                <div style={{ height: 50 }} />


                <Dialog fullScreen style={{ borderRadius: 0 }} maxWidth={'lg'} onClose={() => this.setState({ showDialog: false })} aria-labelledby="customized-dialog-title" open={this.state.showDialog}>

                    <Box
                        display="flex"
                        style={{ marginTop: 20 }}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <div style={{ width: '94%' }}>
                            <AppBar className={{ position: 'relative' }}>
                                <Toolbar onClick={() => this.setState({ showDialog: false })}>
                                    <IconButton edge="start" color="inherit" aria-label="close">
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography style={{ fontFamily: 'Globerbold', flexGrow: 1, fontSize: 24, textTransform: 'uppercase' }}>
                                        {this.state.detailsHeader}
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            
                            <div style={{ height: 10 }} />

                        </div>
                    </Box>


                </Dialog>
            </Fragment>
        )
    }
}
